import Countdown from 'react-countdown';
import React from "react";

function MyCountdown() {
    const currentPath = window.location.pathname;
    const isEn = currentPath.startsWith('/en');

    const offerText = isEn ? 'Offer valid for' : 'Пропозиція діє ще';
    const daysText = isEn ? 'Days' : 'Днів';
    const hoursText = isEn ? 'Hours' : 'Годин';
    const minutesText = isEn ? 'Minutes' : 'Хвилин';
    const secondsText = isEn ? 'Seconds' : 'Секунд';

    const Completionist = () => <span>{isEn ? 'You are good to go!' : 'Час вийшов!'}</span>;

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return <Completionist />;
        } else {
            return (
                <div className="flex w-full max-w-80 text-[#245864]">
                    <div className="text-center mr-6">
                        <div className="font-bold text-3xl lg:text-[48px]">{days}</div>
                        <div className='font-medium'>{daysText}</div>
                    </div>
                    <div className="text-center mr-6">
                        <div className="font-bold text-3xl lg:text-[48px]">{hours}</div>
                        <div className='font-medium'>{hoursText}</div>
                    </div>
                    <div className="text-center mr-6">
                        <div className="font-bold text-3xl lg:text-[48px]">{minutes}</div>
                        <div className='font-medium'>{minutesText}</div>
                    </div>
                    <div className="text-center">
                        <div className="font-bold text-3xl lg:text-[48px]">{seconds}</div>
                        <div className='font-medium'>{secondsText}</div>
                    </div>
                </div>
            );
        }
    };

    return (
        <div>
            <div className="text-[#245864]">
                Пропозиція <span className="uppercase font-bold">early bird</span> діє ще
            </div>
            <Countdown
                date={new Date('2026-11-13T18:00:00')}
                renderer={renderer}
            />
        </div>
    );
}

export default MyCountdown;